var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('creative-lib', { attrs: { "resourceType": 15, "resourceClass": _vm.resourceClass } });
};
var staticRenderFns = [];

export { render, staticRenderFns };